/* ==========================================================================
   Ecco Store — theme.js
   Vanilla JS: header/mobile nav, AJAX cart + drawer, PDP variant picker,
   PLP client-side filtering, accordions, quantity steppers.
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.ECCO_ROUTES || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' };

  /* ---------------------------------------------------------------------
     Utilities
     --------------------------------------------------------------------- */
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return 'Rs. ' + amount;
  }

  /* ---------------------------------------------------------------------
     Header: mobile menu + shop dropdown
     --------------------------------------------------------------------- */
  function initHeader() {
    var mobileBtn = qs('[data-mobile-menu-btn]');
    var mobileNav = qs('[data-mobile-nav]');
    if (mobileBtn && mobileNav) {
      mobileBtn.addEventListener('click', function () {
        mobileNav.classList.toggle('is-open');
      });
    }

    qsa('[data-dropdown-wrap]').forEach(function (wrap) {
      var trigger = qs('[data-dropdown-trigger]', wrap);
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = wrap.classList.contains('is-open');
        qsa('[data-dropdown-wrap]').forEach(function (w) { w.classList.remove('is-open'); });
        if (!isOpen) wrap.classList.add('is-open');
      });
    });
    document.addEventListener('click', function () {
      qsa('[data-dropdown-wrap]').forEach(function (w) { w.classList.remove('is-open'); });
    });
  }

  /* ---------------------------------------------------------------------
     Star ratings — renders SVG stars into any [data-rating] element
     --------------------------------------------------------------------- */
  function renderStars(el) {
    var rating = parseFloat(el.getAttribute('data-rating') || '0');
    var full = Math.floor(rating);
    var half = rating - full >= 0.5;
    var html = '';
    for (var i = 0; i < 5; i++) {
      if (i < full) {
        html += starSVG('full');
      } else if (i === full && half) {
        html += starSVG('half');
      } else {
        html += starSVG('empty');
      }
    }
    el.innerHTML = html;
  }
  function starSVG(type) {
    if (type === 'full') {
      return '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    if (type === 'half') {
      return '<svg viewBox="0 0 24 24"><defs><linearGradient id="halfGrad"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs><path fill="url(#halfGrad)" stroke="currentColor" stroke-width="1" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
  }
  function initStars() {
    qsa('.si6teen-stars[data-rating]').forEach(renderStars);
  }


  /* ---------------------------------------------------------------------
     Cart drawer — AJAX add / update / remove using Shopify Cart & Section
     rendering APIs.
     --------------------------------------------------------------------- */
  var drawer = null, overlay = null;

  function initCartDrawer() {
    drawer = qs('#CartDrawer');
    overlay = qs('#CartDrawerOverlay');
    if (!drawer) return;

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-drawer-close]');
      if (closeBtn) { closeCartDrawer(); }

      var openBtn = e.target.closest('[data-drawer-open]');
      if (openBtn) { e.preventDefault(); openCartDrawer(); }
    });

    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    drawer.addEventListener('click', handleDrawerClick);
    drawer.addEventListener('change', handleDrawerChange);
  }

  function openCartDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('si6teen-drawer-locked');
  }
  function closeCartDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('si6teen-drawer-locked');
  }

  function refreshCartSections() {
    var url = routes.root_url.replace(/\/$/, '') + '/?sections=cart-drawer,cart-icon-bubble';
    return fetchJSON(url).then(function (data) {
      if (data['cart-drawer']) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        var newDrawer = tmp.querySelector('#CartDrawer');
        if (newDrawer && drawer) {
          drawer.innerHTML = newDrawer.innerHTML;
          initStars();
        }
      }
      if (data['cart-icon-bubble']) {
        var tmp2 = document.createElement('div');
        tmp2.innerHTML = data['cart-icon-bubble'];
        var newBubble = tmp2.querySelector('[data-cart-bubble-wrap]');
        qsa('[data-cart-bubble-wrap]').forEach(function (el) {
          if (newBubble) el.innerHTML = newBubble.innerHTML;
        });
      }
    });
  }

  function handleDrawerClick(e) {
    var removeBtn = e.target.closest('[data-remove-line]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(removeBtn.getAttribute('data-remove-line'), 0);
    }
  }
  function handleDrawerChange(e) {
    var select = e.target.closest('[data-qty-select]');
    if (select) {
      changeLine(select.getAttribute('data-qty-select'), parseInt(select.value, 10));
    }
  }

  function changeLine(line, quantity) {
    fetchJSON(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function () {
      refreshCartSections();
      refreshCartPageIfPresent();
    }).catch(function (err) {
      console.error('Cart update failed:', err);
    });
  }

  function refreshCartPageIfPresent() {
    var cartPageRoot = qs('[data-cart-page]');
    if (!cartPageRoot) return;
    var url = routes.root_url.replace(/\/$/, '') + '/?sections=main-cart';
    fetchJSON(url).then(function (data) {
      if (data['main-cart']) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['main-cart'];
        var fresh = tmp.querySelector('[data-cart-page]');
        if (fresh) { cartPageRoot.innerHTML = fresh.innerHTML; initStars(); }
      }
    });
  }

  /* ---------------------------------------------------------------------
     Add-to-cart forms (product cards + PDP)
     --------------------------------------------------------------------- */
  function initAddToCartForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-atc-form]');
      if (!form) return;
      e.preventDefault();
      submitAddToCart(form);
    });
  }

  function submitAddToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var formData = new FormData(form);
    if (btn) { btn.disabled = true; }

    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          // Shopify error payload
          console.error(data.description || 'Could not add to cart');
          if (btn) btn.disabled = false;
          return;
        }
        return refreshCartSections().then(function () {
          openCartDrawer();
          if (btn) {
            btn.disabled = false;
            btn.classList.add('is-added');
            var original = btn.getAttribute('data-original-label') || btn.textContent.trim();
            btn.setAttribute('data-original-label', original);
            var addedLabel = btn.getAttribute('data-added-label') || 'Added to cart ✓';
            var labelEl = btn.querySelector('[data-btn-label]');
            if (labelEl) { labelEl.textContent = addedLabel; } else { btn.textContent = addedLabel; }
            window.setTimeout(function () {
              btn.classList.remove('is-added');
              if (labelEl) { labelEl.textContent = original; } else { btn.textContent = original; }
            }, 1800);
          }
        });
      })
      .catch(function (err) {
        console.error(err);
        if (btn) btn.disabled = false;
      });
  }

  /* ---------------------------------------------------------------------
     Generic accordion (used on PDP + PLP filter sections)
     --------------------------------------------------------------------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var header = e.target.closest('[data-accordion-toggle]');
      if (!header) return;
      var item = header.closest('[data-accordion-item]');
      if (item) item.classList.toggle('is-open');
    });
  }

  /* ---------------------------------------------------------------------
     Wishlist heart toggle (visual only, no persistence)
     --------------------------------------------------------------------- */
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('is-active');
    });
  }

  /* ---------------------------------------------------------------------
     Generic quantity stepper: [data-qty-stepper] wraps input + +/- buttons
     --------------------------------------------------------------------- */
  function initQtySteppers() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = (minus || plus).closest('[data-qty-stepper]');
      if (!wrap) return;
      var input = qs('input', wrap);
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max') || '99', 10);
      var val = parseInt(input.value || '1', 10);
      if (minus) val = Math.max(min, val - 1);
      if (plus) val = Math.min(max, val + 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Cart-page steppers trigger a live /cart/change.js call
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-line-qty]');
      if (!input) return;
      changeLine(input.getAttribute('data-cart-line-qty'), parseInt(input.value, 10));
    });
  }

  /* ---------------------------------------------------------------------
     PDP: gallery + variant picker
     --------------------------------------------------------------------- */
  function initProductDetail() {
    var root = qs('[data-pdp]');
    if (!root) return;

    // Gallery thumbnail swap
    qsa('[data-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var mainImg = qs('[data-main-image]', root);
        if (mainImg && src) mainImg.src = src;
        qsa('[data-thumb]', root).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Thumbnail carousel scroll arrows (only present when > 5 images)
    var thumbCol = qs('[data-thumb-col]', root);
    if (thumbCol) {
      var scrollAmount = 4 * 74;
      var upBtn = qs('[data-thumb-nav="up"]', root);
      var downBtn = qs('[data-thumb-nav="down"]', root);
      if (upBtn) upBtn.addEventListener('click', function () { thumbCol.scrollBy({ top: -scrollAmount, behavior: 'smooth' }); });
      if (downBtn) downBtn.addEventListener('click', function () { thumbCol.scrollBy({ top: scrollAmount, behavior: 'smooth' }); });
    }

    var productJsonEl = qs('[data-product-json]', root);
    if (!productJsonEl) return;
    var product;
    try { product = JSON.parse(productJsonEl.textContent); } catch (err) { return; }

    var selectedOptions = {};
    // GSM → allowed colours mapping (hardcoded to match variant structure)
var GSM_COLOR_MAP = {
  '180': ['Black','White','Bottle Green','Lavender','Navy','Beige'],
  '200': ['Maroon','Grey'],
  '220': ['Black','White','Navy','Offwhite','Brown','Lavender','Sage Green','Beige'],
  '240': ['White','Offwhite','Maroon','Lite Pink','Black','Navy Blue']
};

function updateColorSwatchesForGSM(gsm) {
  var colorGroup = qs('[data-gsm-color-map="true"]', root);
  if (!colorGroup) return;
  var allowed = GSM_COLOR_MAP[gsm] || [];
  var swatches = qsa('[data-option-value]', colorGroup);

  // Show/hide swatches
  swatches.forEach(function(sw) {
    var val = sw.getAttribute('data-option-value');
    if (allowed.indexOf(val) !== -1) {
      sw.classList.remove('is-hidden-gsm');
    } else {
      sw.classList.add('is-hidden-gsm');
      sw.classList.remove('is-active');
    }
  });

  // If current selected colour is not valid for this GSM, pick the first valid one
  var currentColor = selectedOptions['Color'];
  if (allowed.indexOf(currentColor) === -1) {
    var firstValid = swatches.filter(function(sw) {
      return allowed.indexOf(sw.getAttribute('data-option-value')) !== -1;
    })[0];
    if (firstValid) {
      swatches.forEach(function(b) { b.classList.remove('is-active'); });
      firstValid.classList.add('is-active');
      selectedOptions['Color'] = firstValid.getAttribute('data-option-value');
      var labelEl = qs('[data-option-selected-label="Color"]', root);
      if (labelEl) labelEl.textContent = selectedOptions['Color'];
    }
  }
}

qsa('[data-option-name]', root).forEach(function (group) {
  var name = group.getAttribute('data-option-name');
  qsa('[data-option-value]', group).forEach(function (btnEl) {
    btnEl.addEventListener('click', function () {
      qsa('[data-option-value]', group).forEach(function (b) { b.classList.remove('is-active'); });
      btnEl.classList.add('is-active');
      selectedOptions[name] = btnEl.getAttribute('data-option-value');
      var labelValueEl = qs('[data-option-selected-label="' + name + '"]', root);
      if (labelValueEl) labelValueEl.textContent = btnEl.getAttribute('data-option-value');

      // When GSM changes → filter colours
      if (name === 'GSM') {
        updateColorSwatchesForGSM(btnEl.getAttribute('data-option-value'));
      }

      updateForVariant(findVariant());
    });
  });
});

// Run on page load to set correct initial colour swatches
updateColorSwatchesForGSM(selectedOptions['GSM']);

    function findVariant() {
      return product.variants.find(function (v) {
        return product.options.every(function (optName, idx) {
          var key = 'option' + (idx + 1);
          return v[key] === selectedOptions[optName];
        });
      });
    }

    function updateForVariant(variant) {
      var input = qs('[data-variant-id-input]', root);
      var btn = qs('[data-atc-submit]', root);
      var priceEl = qs('[data-variant-price]', root);
      var compareEl = qs('[data-variant-compare-price]', root);
      var skuEl = qs('[data-variant-sku]', root);

      if (variant) {
        if (input) input.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (skuEl) skuEl.textContent = variant.sku || '';
        if (btn) {
          btn.disabled = !variant.available;
          var labelEl = qs('[data-btn-label]', btn);
          var label = variant.available ? (btn.getAttribute('data-in-stock-label') || 'Add to cart') : 'Out of stock';
          if (labelEl) labelEl.textContent = label; else btn.textContent = label;
        }
        // swap main image if variant has a featured image
        if (variant.featured_image) {
          var mainImg = qs('[data-main-image]', root);
          if (mainImg) mainImg.src = variant.featured_image.src || variant.featured_image;
        }
      } else if (btn) {
        btn.disabled = true;
        var labelEl2 = qs('[data-btn-label]', btn);
        if (labelEl2) labelEl2.textContent = 'Unavailable';
      }
    }

    qsa('[data-option-name]', root).forEach(function (group) {
      var name = group.getAttribute('data-option-name');
      qsa('[data-option-value]', group).forEach(function (btnEl) {
        btnEl.addEventListener('click', function () {
          qsa('[data-option-value]', group).forEach(function (b) { b.classList.remove('is-active'); });
          btnEl.classList.add('is-active');
          selectedOptions[name] = btnEl.getAttribute('data-option-value');
          var labelValueEl = qs('[data-option-selected-label="' + name + '"]', root);
          if (labelValueEl) labelValueEl.textContent = btnEl.getAttribute('data-option-value');
          updateForVariant(findVariant());
        });
      });
    });

    // Wishlist on PDP main image
    var wish = qs('[data-main-wishlist]', root);
    if (wish) {
      wish.addEventListener('click', function () { wish.classList.toggle('is-active'); });
    }
  }

  /* ---------------------------------------------------------------------
     PLP: client-side filter / sort of already-rendered product cards.
     Works against data attributes rendered by the liquid template.
     --------------------------------------------------------------------- */
  function initPLPFilters() {
    var root = qs('[data-plp]');
    if (!root) return;
    var grid = qs('[data-plp-grid]', root);
    if (!grid) return;
    var cards = qsa('[data-plp-card]', grid);
    var resultsCountEl = qs('[data-plp-results-count]', root);

    var state = { colors: [], sizes: [], minPrice: null, maxPrice: null, sort: 'popular' };

    function apply() {
      var visible = cards.filter(function (card) {
        var cardColors = (card.getAttribute('data-colors') || '').split(',').filter(Boolean);
        var cardSizes = (card.getAttribute('data-sizes') || '').split(',').filter(Boolean);
        var price = parseFloat(card.getAttribute('data-price') || '0');

        if (state.colors.length && !state.colors.some(function (c) { return cardColors.indexOf(c) !== -1; })) return false;
        if (state.sizes.length && !state.sizes.some(function (s) { return cardSizes.indexOf(s) !== -1; })) return false;
        if (state.minPrice !== null && price < state.minPrice) return false;
        if (state.maxPrice !== null && price > state.maxPrice) return false;
        return true;
      });

      cards.forEach(function (c) { c.style.display = 'none'; });

      var sorters = {
        'price-low': function (a, b) { return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price')); },
        'price-high': function (a, b) { return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price')); },
        'rating': function (a, b) { return parseFloat(b.getAttribute('data-rating')) - parseFloat(a.getAttribute('data-rating')); },
        'newest': function (a, b) { return parseInt(b.getAttribute('data-new')) - parseInt(a.getAttribute('data-new')); },
      };
      if (sorters[state.sort]) {
        visible.sort(sorters[state.sort]);
        visible.forEach(function (c) { grid.appendChild(c); });
      }
      visible.forEach(function (c) { c.style.display = ''; });

      if (resultsCountEl) {
        resultsCountEl.innerHTML = 'Showing <strong>' + visible.length + '</strong> of ' + cards.length + ' products';
      }
    }

    qsa('[data-filter-color]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        var val = input.getAttribute('data-filter-color');
        if (input.checked) { state.colors.push(val); } else { state.colors = state.colors.filter(function (c) { return c !== val; }); }
        renderActiveChips();
        apply();
      });
    });
    qsa('[data-filter-size]', root).forEach(function (btnEl) {
      btnEl.addEventListener('click', function () {
        var val = btnEl.getAttribute('data-filter-size');
        btnEl.classList.toggle('is-active');
        if (btnEl.classList.contains('is-active')) { state.sizes.push(val); } else { state.sizes = state.sizes.filter(function (s) { return s !== val; }); }
        apply();
      });
    });
    var priceSlider = qs('[data-price-slider]', root);
    if (priceSlider) {
      priceSlider.addEventListener('input', function () {
        state.maxPrice = parseFloat(priceSlider.value);
        var maxDisplay = qs('[data-price-max-display]', root);
        if (maxDisplay) maxDisplay.textContent = window.themeMoneyFormat ? Shopify.formatMoney(priceSlider.value * 100, window.themeMoneyFormat) : (priceSlider.value + '.00');
        apply();
      });
    }
    qsa('[data-sort-radio]', root).forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) { state.sort = radio.value; apply(); }
      });
    });
    var sortSelect = qs('[data-plp-sort-select]', root);
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        apply();
      });
    }

    function renderActiveChips() {
      var chipsWrap = qs('[data-active-filter-chips]', root);
      if (!chipsWrap) return;
      chipsWrap.innerHTML = state.colors.map(function (c) {
        return '<span class="si6teen-active-filter-chip">' + c + '<button type="button" data-remove-color-chip="' + c + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg></button></span>';
      }).join('');
    }
    document.addEventListener('click', function (e) {
      var chipBtn = e.target.closest('[data-remove-color-chip]');
      if (!chipBtn) return;
      var val = chipBtn.getAttribute('data-remove-color-chip');
      var input = qs('[data-filter-color="' + val + '"]', root);
      if (input) { input.checked = false; input.dispatchEvent(new Event('change')); }
    });

    // Color dots on listing cards (switch which swatch is highlighted, cosmetic)
    qsa('[data-card-color-dot]', root).forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = dot.closest('[data-plp-card]');
        qsa('[data-card-color-dot]', card).forEach(function (d) { d.classList.remove('is-active'); });
        dot.classList.add('is-active');
      });
    });

    // Filter section collapse
    qsa('[data-filter-section]', root).forEach(function (section) {
      var header = qs('[data-filter-section-toggle]', section);
      if (header) header.addEventListener('click', function () { section.classList.toggle('is-open'); });
    });

    // Init default open state + first paint
    renderActiveChips();
  }

  /* ---------------------------------------------------------------------
     Homepage "find your favorite products" tab + load-more (client-side)
     --------------------------------------------------------------------- */
  function initHomeProductTabs() {
    qsa('[data-pls]').forEach(function (root) {
      var grid = qs('[data-pls-grid]', root);
      if (!grid) return;
      var initialCount = parseInt(grid.getAttribute('data-initial-count'), 10) || 6;
      var loadMoreBtn = qs('[data-pls-load-more]', root);
      var resultsEl = qs('[data-pls-results-count]', root);
      var activeCategory = 'all';

      function itemMatches(item) {
        if (activeCategory === 'all') return true;
        var cats = (item.getAttribute('data-pls-category') || '').split(',');
        return cats.indexOf(activeCategory) !== -1;
      }

      function applyFilter() {
        var items = qsa('[data-pls-item]', grid);
        var matches = items.filter(itemMatches);
        var nonMatches = items.filter(function (item) { return !itemMatches(item); });

        nonMatches.forEach(function (item) {
          item.style.display = 'none';
          item.setAttribute('data-pls-hidden', 'true');
        });

        matches.forEach(function (item, i) {
          if (i < initialCount) {
            item.style.display = '';
            item.setAttribute('data-pls-hidden', 'false');
          } else {
            item.style.display = 'none';
            item.setAttribute('data-pls-hidden', 'true');
          }
        });

        var shownCount = Math.min(initialCount, matches.length);
        if (resultsEl) resultsEl.textContent = 'Showing ' + shownCount + ' of ' + matches.length + ' products';
        if (loadMoreBtn) loadMoreBtn.style.display = matches.length > initialCount ? '' : 'none';
      }

      qsa('[data-pls-tab]', root).forEach(function (tab) {
        tab.addEventListener('click', function () {
          qsa('[data-pls-tab]', root).forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');
          activeCategory = tab.getAttribute('data-pls-tab-value') || 'all';
          applyFilter();
        });
      });

      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {
          var items = qsa('[data-pls-item]', grid);
          var hiddenMatches = items.filter(itemMatches).filter(function (item) {
            return item.getAttribute('data-pls-hidden') === 'true';
          }).slice(0, 6);
          hiddenMatches.forEach(function (item) {
            item.style.display = '';
            item.setAttribute('data-pls-hidden', 'false');
          });
          var stillHidden = items.filter(itemMatches).some(function (item) {
            return item.getAttribute('data-pls-hidden') === 'true';
          });
          if (!stillHidden) loadMoreBtn.style.display = 'none';
          var shownNow = items.filter(itemMatches).filter(function (item) {
            return item.getAttribute('data-pls-hidden') !== 'true';
          }).length;
          var totalMatches = items.filter(itemMatches).length;
          if (resultsEl) resultsEl.textContent = 'Showing ' + shownNow + ' of ' + totalMatches + ' products';
        });
      }
    });
  }

  /* ---------------------------------------------------------------------
     Flash sale countdown: [data-countdown][data-countdown-end="ISO date"]
     --------------------------------------------------------------------- */
  function initCountdownTimers() {
    var timers = qsa('[data-countdown]');
    if (!timers.length) return;
    function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
    function tick() {
      timers.forEach(function (el) {
        var end = new Date(el.getAttribute('data-countdown-end')).getTime();
        var diff = Math.max(0, end - Date.now());
        var hours = Math.floor(diff / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        var h = qs('[data-countdown-hours]', el);
        var m = qs('[data-countdown-minutes]', el);
        var s = qs('[data-countdown-seconds]', el);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(minutes);
        if (s) s.textContent = pad(seconds);
      });
    }
    tick();
    setInterval(tick, 1000);
  }
  /* ---------------------------------------------------------------------
     Flash sale countdown: [data-countdown][data-countdown-end="ISO date"]
     --------------------------------------------------------------------- */
  function initCountdownTimers() {
    var timers = qsa('[data-countdown]');
    if (!timers.length) return;
    function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
    function tick() {
      timers.forEach(function (el) {
        var end = new Date(el.getAttribute('data-countdown-end')).getTime();
        var diff = Math.max(0, end - Date.now());
        var hours = Math.floor(diff / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        var h = qs('[data-countdown-hours]', el);
        var m = qs('[data-countdown-minutes]', el);
        var s = qs('[data-countdown-seconds]', el);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(minutes);
        if (s) s.textContent = pad(seconds);
      });
    }
    tick();
    setInterval(tick, 1000);
  }
  /* ---------------------------------------------------------------------
     Init
     --------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initStars();
    initCartDrawer();
    initAddToCartForms();
    initAccordions();
    initWishlist();
    initQtySteppers();
    initProductDetail();
    initPLPFilters();
    initHomeProductTabs();
    initCountdownTimers();
  });
})();
